import React, { useEffect, useRef, useState } from "react";
import {
  Navbar,
  Nav,
  Button,
  Container,
  Row,
  Col,
  Dropdown,
  InputGroup,
  Input,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import styles from "./Header.module.scss";
import MaelanoIcon from "../../../../assets/icons/MaelanoIcon.png";
import dropdownData from "./headerOptionsData";
import CartIcon from "../../../../assets/icons/CartIcon.png";
import axios from "axios";
import { API_URLS } from "../../../../utility/api/endpoints/endpoints";
import { useNavigate } from "react-router-dom";
import { FaDollarSign, FaEuroSign, FaPoundSign } from 'react-icons/fa';
import { IoLanguageSharp } from 'react-icons/io5';
import Flag from 'react-world-flags';
import { auto } from "@popperjs/core";

const menuItems = [
  {
    title: "Automobiles",
    subMenu: ["Rac Cars", "Bikes", "Trucks"],
    icon: <i className="fa fas fa-car"></i>,
  },
  {
    title: "Gifts and Toys",
    subMenu: ["Cars", "Wooden Toys", "Ships"],
    icon: <i className="fa fas fa-gamepad"></i>,
  },
  {
    title: "Home & Office",
    subMenu: ["Office Furniture", "Lighting", "Decor"],
    icon: <i className=" fa fas fa-home"></i>,
  },
  {
    title: "Electronics",
    subMenu: ["TVs", "Laptops", "Smartphones"],
    icon: <i className="fa fas fa-plug"></i>,
  },
  {
    title: "Fashion",
    subMenu: ["Men", "Women", "Accessories"],
    icon: <i className="fa fas fa-user"></i>,
  },
  // add more items as needed...
]

const SubMenu = ({ categories, setCategoryId, setShowMenu }) => {
  const navigate = useNavigate()
  const [hoveredIndex, setHoveredIndex] = useState(null)

  const handleClick = (id, name) => {
    setCategoryId(id)
    setShowMenu(false)
    navigate("/product-listing", { state: { categoryId: id, categoryName: name } })
  }

  return (
    <div className={styles.subMenu}>
      {categories.length > 0 ? (
        categories.map((category, index) => (
          <React.Fragment key={category._id}>
            <div className={styles.menuItem}>
              <div
                className={styles.categoryName}
                style={{
                  // paddingLeft: `${level * 6}px`,
                  cursor: "pointer",
                  transition: "color 0.3s ease",
                  color: hoveredIndex === index ? "#FFA500" : category?.level === 2 ? "#EC7426" : "inherit",
                  fontSize: category?.level === 2 ? '15px' : '14px',
                  fontWeight: category?.level === 2 ? 600 : 400,
                  textTransform: category?.level === 2 && "uppercase"
                }}
                onClick={() => handleClick(category._id, category.name)}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {category.name}
              </div>
            </div>

            {category.level <= 2 && (
              <>
                {category.childCategories && category.childCategories.length > 0 && (
                  <SubMenu categories={category.childCategories} setCategoryId={setCategoryId} setShowMenu={setShowMenu} />
                )}
              </>
            )}
          </React.Fragment>
        ))
      ) : (
        <p className={styles.noSubMenu}>No sub-menu available</p>
      )}
    </div>
  )
}

const Header = () => {
  // Dynamic data for languages and currencies
  const languages = [
    { code: 'PAK', name: 'English' },
    { code: 'GB', name: 'English' }, // 'GB' for the UK flag
    { code: 'ES', name: 'Spanish' }, // 'ES' for Spain
    { code: 'FR', name: 'French' },  // 'FR' for France
  ];

  const currencies = [
    { code: 'usd', name: 'US Dollars', icon: <FaDollarSign /> },
    { code: 'eur', name: 'Euro', icon: <FaEuroSign /> },
    { code: 'gbp', name: 'British Pound', icon: <FaPoundSign /> },
  ];

  // States for selected options
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);
  const [selectedCurrency, setSelectedCurrency] = useState(currencies[0]);

  // States for handling dropdowns
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false)
  const [currencyDropdownOpen, setCurrencyDropdownOpen] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState({})

  // Toggle functions for dropdowns
  const toggleLanguageDropdown = () => setLanguageDropdownOpen(!languageDropdownOpen)
  const toggleCurrencyDropdown = () => setCurrencyDropdownOpen(!currencyDropdownOpen)

  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)

  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [categoryId, setCategoryId] = useState("")

  // Toggle dropdowns individually
  const toggleDropdown = (index) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }))
  }

  const [showMenu, setShowMenu] = useState(false)
  const [activeMenu, setActiveMenu] = useState(null)

  const handleMenuToggle = () => {
    setShowMenu(!showMenu)
  }

  const handleMouseEnter = (index, subCategories) => {
    setSubCategories(subCategories)
    setActiveMenu(index)
  }

  useEffect(() => {
    const fetchCategories = async () => {
      const { data } = await axios.get(API_URLS.GET_ALL_CATEGORIES)
      setCategories(data.data)
    }

    fetchCategories()
  }, [])

  const menuRef = useRef(null)

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setShowMenu(false)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <>
      {/* Top bar */}
      <Container fluid className={`py-1 ${styles.headerTopBar}`}>
        <Row className="justify-content-between align-items-center">
          <Col sm={12} md={auto} className={styles.welcomeTagline}>
            <span>Welcome to MAELANO, Have Happy Shopping</span>
          </Col>

          <Col sm={12} md={auto} className={styles.dropdownBtns}>
            {/* Language Dropdown */}
            <Dropdown isOpen={languageDropdownOpen} toggle={toggleLanguageDropdown} className="mx-2">
              <DropdownToggle tag="a" caret className={`p-0 text-body text-decoration-none ${styles.customDropdown}`}>
                <Flag code={selectedLanguage.code} className={styles.flagIcon} />{' '}
                {selectedLanguage.name.toUpperCase()}
              </DropdownToggle>
              <DropdownMenu>
                {languages.map((lang) => (
                  <DropdownItem
                    key={lang.code}
                    onClick={() => setSelectedLanguage(lang)}
                    active={selectedLanguage.code === lang.code}
                    className={styles.dropdownItem}
                  >
                    <Flag code={lang.code} className={styles.flagIcon} /> {lang.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>

            {/* Currency Dropdown */}
            <Dropdown isOpen={currencyDropdownOpen} toggle={toggleCurrencyDropdown} className="mx-2">
              <DropdownToggle tag="a" caret className={`p-0 text-body text-decoration-none ${styles.customDropdown}`}>
                {selectedCurrency.icon} {selectedCurrency.name.toUpperCase()}
              </DropdownToggle>
              <DropdownMenu>
                {currencies.map((currency) => (
                  <DropdownItem
                    key={currency.code}
                    onClick={() => setSelectedCurrency(currency)}
                    active={selectedCurrency.code === currency.code}
                    className={styles.dropdownItem}
                  >
                    {currency.icon} {currency.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </Col>
        </Row>
      </Container>

      {/* Main Navigation */}
      <Navbar expand="lg" className={styles.headerNavbar}>
        <Container fluid className={styles.headerContainer}>
          <NavbarBrand href="/landingpage" className="p-0">
            <img src={MaelanoIcon} alt="Logo" className="bg-white p-2 px-1 rounded-3" />
          </NavbarBrand>

          <NavbarToggler onClick={toggle} type="button" className={styles.navbarToggler} />

          <Collapse isOpen={isOpen} navbar className={styles.navbarCollapse}>
            <Nav className={styles.navbarDropdowns} navbar>
              {dropdownData?.map((dropdown, index) =>
                dropdown?.items?.length > 0 ? (
                  <Dropdown
                    nav
                    inNavbar
                    key={index}
                    isOpen={dropdownOpen[index] || false}
                    toggle={() => toggleDropdown(index)}
                    className={styles.dropdownNav}
                  >
                    <DropdownToggle nav caret className={styles.customDropdown}>
                      {dropdown?.title}
                    </DropdownToggle>
                    <DropdownMenu className={styles.customDropdownMenu}>
                      {dropdown?.items?.map((item, itemIndex) => (
                        <DropdownItem href={item?.link} key={itemIndex}>
                          {item?.label}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                ) : (
                  <NavLink key={index} href={dropdown?.link || "#"} className={styles.customDropdown}>
                    {dropdown?.title}
                  </NavLink>
                )
              )}
            </Nav>

            <Nav className={styles.headerIcons} navbar>
              <NavItem>
                <NavLink href="/choose-role" className={styles.headerNavLinks}>
                  <i className="fa fa-solid fa-user"></i> Login/Register
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#" className={styles.headerNavLinks}>
                  <i className="fa fa-solid fa-truck"></i> Track your Order
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="tel:+3111222333" className={styles.headerNavLinkLast}>
                  <i className="fa fa-solid fa-phone"></i> Helpline +3-111-222-333
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>

      {/* Categories Bar */}
      <Container fluid className={`d-flex align-items-center justify-content-between py-0 text-white ${styles.headerCategories}`}>
        <div className={styles.categoriesBtnMenu} ref={menuRef}>
          <Button type="button" color="black" onClick={handleMenuToggle} className={styles.categoryBtn}>
            <i className="fa fa-solid fa-list"></i>
            <span>CATEGORIES</span>
          </Button>

          {showMenu && (
            <div className={styles.menu}>
              <div className={styles.mainMenu}>
                <ul className="list-unstyled" style={{ listStylePosition: "outside" }}>
                  {categories?.map((item, index) => (
                    <li key={index} onMouseEnter={() => handleMouseEnter(index, item.childCategories || "")} className={styles.menuItem}>
                      <span className={styles.menuIcon}>
                        <img src={item.icon || `https://placehold.co/24x24?text=Maelano`} alt="" style={{ height: "24px", width: "24px" }} />
                      </span>
                      <span>{item.name}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {activeMenu !== null && <SubMenu categories={subCategories} setCategoryId={setCategoryId} setShowMenu={setShowMenu} />}
            </div>
          )}
        </div>

        <InputGroup className={styles.inputGrp}>
          <Input type="text" placeholder="Looking for something specific?" className={styles.searchField} />
          <Button type="button" color="black" className={styles.searchBtn}>
            <i className="fa fa-search d-block"></i>
          </Button>
        </InputGroup>

        <Nav className={styles.categoriesBarIcons}>
          <NavItem>
            <NavLink href="#" className="py-0 px-2 text-white">
              <i className="fa fa-regular fa-bell"></i>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="#" className="py-0 px-2 text-white">
              <i className="fa fa-solid fa-gift"></i>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="#" className="py-0 px-2 text-white">
              <i className="fa fa-heart"></i>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="#" className={styles.cartLink}>
              <div className={styles.cartIconWrapper}>
                <img src={CartIcon} alt="Cart Icon" className={styles.cartIconImg} />
                <span className={styles.cartAmount}>$00.00</span>
              </div>
              <p className={styles.cardText}>Cart</p>
            </NavLink>
          </NavItem>
        </Nav>
      </Container>
    </>
  )
}

export default Header
